import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../../../components/Spinner/Spinner';
import CardInfo from '../../../components/CardInfo/CardInfo';
import selectors from './employeeManagementTabSelectors';
import { createKeyfobs } from './employeeManagementActions';
import KeyfobsAndEmployeesList from './KeyfobsAndEmployeesList/KeyfobsAndEmployeesList';
import UploadMemberRecipientsForm from './UploadMemberRecipients/UploadMemberRecipientsForm/UploadMemberRecipientsForm';

function EmployeeManagementTab({ match, isLoading, partner, createKeyfobs, launchDate }) {
    const partnerId = Number(match.params.partnerId);

    return <CardInfo shadow={false} halfSpace noPadding noInnerMargin>
        {isLoading ? <Spinner /> : null}
        {<UploadMemberRecipientsForm partnerId={partnerId} launchDate={launchDate} className="info-box--grid__row" />}
        <KeyfobsAndEmployeesList partnerId={partnerId} />
    </CardInfo>;
}

EmployeeManagementTab.propTypes = {
    match: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    partner: PropTypes.object.isRequired,
    createKeyfobs: PropTypes.func.isRequired,
    employeesList: PropTypes.array,
    launchDate: PropTypes.instanceOf(Date).isRequired,
};
const mapDispatchToProps = {
    createKeyfobs
};
const connectStateToProps = connect(selectors, mapDispatchToProps);
export default connectStateToProps(EmployeeManagementTab);
